import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowUpRight } from 'react-icons/fi';

const FeatureCard = ({ app, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="group relative"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white to-gray-50 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      <div className="relative glass-effect rounded-3xl p-8 border border-gray-200 hover-lift">
        {/* Icon with Gradient Background */}
        <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${app.gradient} flex items-center justify-center mb-6`}>
          <span className="text-2xl">{app.icon}</span>
        </div>

        {/* Title */}
        <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:gradient-text transition-all duration-300">
          {app.title}
        </h3>

        {/* Description */}
        <p className="text-gray-600 mb-6 leading-relaxed">
          {app.description}
        </p>

        {/* Features List */}
        <ul className="space-y-3 mb-6">
          {app.features.map((feature, idx) => (
            <motion.li
              key={idx}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: idx * 0.1 }}
              className="flex items-center text-gray-700"
            >
              <div className="w-2 h-2 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 mr-3"></div>
              {feature}
            </motion.li>
          ))}
        </ul>

        {/* Extra Info */}
        <div className="pt-6 border-t border-gray-100">
          <p className="text-sm text-gray-500 italic">{app.extra}</p>
        </div>

        {/* Hover Arrow */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileHover={{ opacity: 1, x: 0 }}
          className="absolute top-8 right-8 opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <div className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center">
            <FiArrowUpRight className="w-5 h-5 text-white" />
          </div>
        </motion.div>

        {/* Glow Effect */}
        <div className={`absolute inset-0 rounded-3xl bg-gradient-to-br ${app.gradient} opacity-0 group-hover:opacity-10 blur-xl transition-opacity duration-500 -z-10`}></div>
      </div>
    </motion.div>
  );
};

export default FeatureCard;